// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
//import {get, post } from './JS/ajax'
import utils from './JS/utils'
// import vConsole from './JS/vconsole'
import toast from './components/toast'
import Dialog from './components/dialog'
import Loadings from './components/loadings'
import VuePreview from 'vue-preview'
import VueScroller from 'vue-scroller'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import swiper from 'vue-awesome-swiper'
import swiperSlide from 'vue-awesome-swiper'

Vue.use(swiper)
Vue.use(swiperSlide)
Vue.use(VueAwesomeSwiper)
import 'swiper/dist/css/swiper.css'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

Vue.use(VuePreview,{
  mainClass: 'pswp--minimal--dark',
  barsSize: {top: 0, bottom: 0},
  captionEl: false,
  fullscreenEl: false,
  shareEl: false,
  bgOpacity: 0.8,
  tapToClose: true,
  tapToToggleControls: true
})

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
var option = {
  maxSpreadZoom: 1, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: false, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: false, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  arrowEl: true,  //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
}
Vue.use(preview, option)




Vue.use(VueScroller)
Vue.use(utils)

//Vue.use(Dialog)
//Vue.use(Loading)



Vue.prototype.$toast = toast
Vue.prototype.$dialog = Dialog

// Vue.prototype.$loading = Loadings
Vue.prototype.Loadings = Loadings
//Vue.prototype.$axios = { get, post }

Vue.config.productionTip = false
let cale = window.screen.availWidth > 818 ? 2 : window.screen.availWidth / 414
window.document.documentElement.style.fontSize = `${100 * cale}px`
export default new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

export const bus = new Vue()
Vue.prototype.$bus = bus



// WEBPACK FOOTER //
// ./src/main.js